export default __webpack_public_path__ + "static/media/f_discord.6c132d2c.svg";